/** Maps backend `best_fit.model` keys to Big-O display strings (shared by Calculator + explainer). */
export const TIME_COMPLEXITY_NOTATION = {
  constant: 'O(1)',
  linear: 'O(n)',
  quadratic: 'O(n^2)',
  logarithmic: 'O(log n)',
  exponential: 'O(2^n)',
  cubic: 'O(n^3)',
  log_linear: 'O(n log n)',
  factorial: 'O(n!)',
  polynomial: 'O(n^k)',
  inverse_ackermann: 'O(α(n))',
  iterated_logarithmic: 'O(log* n)',
  log_logarithmic: 'O(log log n)',
  polylogarithmic: 'O((log n)^k)',
  fractional_power: 'O(n^c)',
  quasilinear: 'O(n log^k n)',
  quasi_polynomial: 'O(exp((log n)^k))',
  subexponential: 'O(exp(n^c))',
  subexponential_variant: '2^(o(n))',
  polynomial_linear_exponent: 'O(2^(O(n)))',
  double_exponential: 'O(2^(2^n))',
  exponential_poly: 'O(2^(poly(n)))',
};
